<template lang="pug">
v-carousel(
  v-model="inputValue"
  :height="height"
  :show-arrows="hasMoreThanOneImage"
  hide-delimiters
).image-carousel.rounded-32.overflow-hidden
  template(v-for="(item, index) in images")
    v-carousel-item(
      :key="index"
      :class="{ 'cursor-pointer': showImageDialog || showImageSliderDialog }"
      :src="item.url"
      :lazy-src="constants.PlaceholderImage"
      :ripple="false"
      @click="$emit('show-image')"
    ).image-carousel__img
  template(#prev="{ on }")
    app-button(
      color="white"
      :width="40"
      :height="40"
      rounded
      fab
      v-on="on"
    ).redesign-box-shadow
      v-icon(
        color="redesignBlack"
        :size="20"
      ).icon--prev $ichevron-down
  template(#next="{ on }")
    app-button(
      color="white"
      :width="40"
      :height="40"
      rounded
      fab
      v-on="on"
    ).redesign-box-shadow
      v-icon(
        color="redesignBlack"
        :size="20"
      ).icon--next $ichevron-down
</template>

<script>
import PlaceholderImage from '@/assets/placeholder.jpg';

export default {
  name: 'ImageCarousel',
  components: {},
  props: {
    // current slide index
    value: {
      type: Number,
      default: 0,
    },
    images: {
      type: Array,
      required: true,
    },
    carousel: {
      type: Boolean,
      default: false,
    },
    showImageDialog: {
      type: Boolean,
      default: false,
    },
    showImageSliderDialog: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [Number, String],
      default: 560,
    },
  },
  data() {
    return {};
  },
  computed: {
    constants() {
      return {
        PlaceholderImage,
      };
    },
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    hasMoreThanOneImage() {
      return this.images.length > 1;
    },
    isFirstSlide() {
      return this.inputValue === 0;
    },
    isLastSlide() {
      return this.inputValue === this.images.length - 1;
    },
  },
  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.image-carousel {
  &__img {
    max-height: 80vh;
  }

  &::v-deep .v-window__prev,
  &::v-deep .v-window__next {
    background: none !important;
  }
}
.icon {
  &--prev {
    transform: rotate(90deg);
  }

  &--next {
    transform: rotate(270deg);
  }
}
</style>
